// import React from "react";
// import { withRouter } from "react-router-dom";
// import SRI from './images/SRI.jpg';
// import './styles/bootstrap.min.css';
// import './styles/animate.css';
// import './styles/tiny-slider.css';
// import './styles/glightbox.min.css';
// import './styles/main.css';
// function Header(props) {
//   const [isOpen, setIsOpen] = React.useState(false);
//   const toggleNavbar = () => {
//     setIsOpen(!isOpen);
//   };
//   const handleOpen = () => {
//     props.history.push('/sriqr/login') 
// };
// const handleChange=()=>{
//     props.history.push('/sriqr/profileregistration') 
// }
// const handleLogin=()=>{
//     props.history.push('/sriqr/branchuser') 
// }
// const handleUser=()=>{
//     props.history.push('/sriqr/inspectorlogin') 
// }
//   return (
  
//     <>
//     <header class="header navbar-area sticky">
//         <div class="container">
//             <div class="row align-items-center">
//                 <div class="col-lg-12">
//                     <div class="nav-inner">
                       
//                         <nav class="navbar navbar-expand-lg">
//                             <a class="navbar-brand" href="index.html">
//                                 {/* <img src="assets/images/logo/white-logo.svg" alt="Logo"/> */}
//                                 <img src={SRI} alt="some example image" style={{height:"70px", width:"70px"}}/>
//                                 {/* <img src="home/images/SRIQR.COM LOGO JPG.jpg" alt="Sriqr.com"/> */}

//                             </a>
//                             <button class="navbar-toggler mobile-menu-btn" onClick={toggleNavbar} type="button" data-bs-toggle="collapse"
//                                 data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
//                                 aria-expanded="false" aria-label="Toggle navigation">
//                                 <span class="toggler-icon"></span>
//                                 <span class="toggler-icon"></span>
//                                 <span class="toggler-icon"></span>
//                             </button>
//                             {isOpen? <div class=" navbar-collapse sub-menu-bar" id="navbarSupportedContent">
//                                         <ul id="nav" class="navbar-nav ms-auto">
//                                             <li class="nav-item">
//                                                 <a href="#home" class="page-scroll active"
//                                                     aria-label="Toggle navigation">Home</a>
//                                             </li>
//                                             <li class="nav-item">
//                                 <a href="javascript:void(0)" onClick={handleOpen} class="page-scroll active"> Client Login</a>
//                             </li>
//                             <li class="nav-item">
//                                                 <a href="javascript:void(0)" onClick={handleChange}  class="page-scroll active"
//                                                     aria-label="Toggle navigation"> Profile Registration</a>
//                                             </li>
//                                             <li class="nav-item">
//                                                 <a href="javascript:void(0)" onClick={handleUser}  class="page-scroll active"
//                                                     aria-label="Toggle navigation">Ticket Inspector</a>
//                                             </li>
                                            
                            
//                                         </ul>
//                                     </div>:<div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
//                                         <ul id="nav" class="navbar-nav ms-auto">
//                                             <div class="nav-item">
//                                                 <a href="#home" class="page-scroll active"
//                                                     aria-label="Toggle navigation">Home</a>
//                                             </div>
//                                             <div class="nav-item">
//                                             <a href="javascript:void(0)" onClick={handleOpen} class="page-scroll active"> Client Login</a>
//                                             </div>
//                                             <div class="nav-item">
//                                                 <a href="javascript:void(0)" onClick={handleChange} class="page-scroll active"
//                                                     aria-label="Toggle navigation">Profile Registration</a>
//                                             </div>
//                                             <div class="nav-item">
//                                                 <a href="javascript:void(0)" onClick={handleLogin} class="page-scroll active"
//                                                     aria-label="Toggle navigation">Counter Login</a>
//                                             </div>
//                                             <div class="nav-item">
//                                                 <a href="javascript:void(0)" onClick={handleUser} class="page-scroll active"
//                                                     aria-label="Toggle navigation">Ticket Inspector</a>
//                                             </div>
//                                         </ul>
//                                     </div>}
//                             {/* <div class="button add-list-button">
//                                 <a href="javascript:void(0)" onClick={handleOpen} class="btn">gg Admin Login</a>
//                             </div> */}
//                         </nav>
                        
//                     </div>
//                 </div>
//             </div> 
//         </div> 
//     </header>
//     </>
//   );
// }

// export default withRouter(Header);
import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import SRI from './images/SRI.jpg';
import home from './images/sriqr.svg';
import './styles/bootstrap.min.css';
import './styles/animate.css';
import './styles/tiny-slider.css';
import './styles/glightbox.min.css';
import './styles/main.css';

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const loginDropdownRef = useRef(null);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const toggleLoginDropdown = () => {
    setLoginDropdownOpen(!loginDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
    };

    if (loginDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [loginDropdownOpen]);

  const handleOpen = () => {
    props.history.push('/login');
  };

  const handleChange = () => {
    props.history.push('/profileregistration');
  };

  const handleLogin = () => {
    props.history.push('/branchuser');
  };

  const handleUser = () => {
    props.history.push('/inspectorlogin');
  };

  const handlePrivacyPolicy = () => {
    props.history.push('/privacypolicy');
  };
  const handleEvents = () => {
    props.history.push('/events');
  };
  
  const handleServicesClick = (e) => {
    e.preventDefault();
    // If not on home page, navigate to home first
    if (props.location.pathname !== '/home' && props.location.pathname !== '/') {
      props.history.push('/home');
      setTimeout(() => {
        const servicesSection = document.getElementById('services');
        if (servicesSection) {
          const headerOffset = 100;
          const elementPosition = servicesSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const servicesSection = document.getElementById('services');
      if (servicesSection) {
        const headerOffset = 100;
        const elementPosition = servicesSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };
  
  const handleHowItWorksClick = (e) => {
    e.preventDefault();
    if (props.location.pathname !== '/home' && props.location.pathname !== '/') {
      props.history.push('/home');
      setTimeout(() => {
        const section = document.getElementById('how-it-works');
        if (section) {
          const headerOffset = 100;
          const elementPosition = section.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const section = document.getElementById('how-it-works');
      if (section) {
        const headerOffset = 100;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };
  
  const handleContactClick = (e) => {
    e.preventDefault();
    props.history.push('/contact');
  };
  
  const handleFeaturesClick = (e) => {
    e.preventDefault();
    if (props.location.pathname !== '/home' && props.location.pathname !== '/') {
      props.history.push('/home');
      setTimeout(() => {
        const section = document.getElementById('features');
        if (section) {
          const headerOffset = 100;
          const elementPosition = section.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const section = document.getElementById('features');
      if (section) {
        const headerOffset = 100;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };
  
  // Dynamically load the script
  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2277440900291589";
  //   script.async = true;
  //   script.crossOrigin = "anonymous";
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <>
      <header className="header navbar-area sticky">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="nav-inner">
                <nav className="navbar navbar-expand-lg" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <a className="navbar-brand" href="index.html" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
                    <img src={SRI} alt="some example image" style={{ height: "70px", width: "70px" }} />
                    <span style={{ 
                      fontSize: '28px', 
                      fontWeight: 'bold', 
                      color: '#1976d2',
                      letterSpacing: '1px',
                      fontFamily: 'Arial, sans-serif',
                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                      SRIQR.com
                    </span>
                  </a>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <button
                    className="navbar-toggler mobile-menu-btn"
                    onClick={toggleNavbar}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="toggler-icon"></span>
                    <span className="toggler-icon"></span>
                    <span className="toggler-icon"></span>
                  </button>
                  {/* <div className="dropdown" ref={loginDropdownRef} style={{ position: 'relative', display: isOpen ? 'none' : 'block' }}>
                    <button 
                      className="btn btn-primary" 
                      type="button" 
                      onClick={toggleLoginDropdown}
                      style={{ 
                        backgroundColor: '#ffffff', 
                        color: '#1976d2',
                        border: '2px solid #1976d2',
                        padding: '8px 20px',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 600,
                        textTransform: 'none',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#1976d2';
                        e.target.style.color = '#ffffff';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#ffffff';
                        e.target.style.color = '#1976d2';
                      }}
                    >
                      Login
                    </button>
                    {loginDropdownOpen && (
                      <div 
                        className="dropdown-menu show" 
                        style={{ 
                          position: 'absolute', 
                          right: 0, 
                          top: '100%',
                          minWidth: '180px',
                          zIndex: 1000,
                          backgroundColor: 'white',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          borderRadius: '8px',
                          padding: '8px 0',
                          marginTop: '8px'
                        }}
                      >
                        <a 
                          className="dropdown-item" 
                          href="javascript:void(0)" 
                          onClick={() => {
                            handleOpen();
                            setLoginDropdownOpen(false);
                          }}
                          style={{ 
                            padding: '12px 20px', 
                            display: 'block',
                            color: '#333',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          Client Login
                        </a>
                        <a 
                          className="dropdown-item" 
                          href="javascript:void(0)" 
                          onClick={() => {
                            handleLogin();
                            setLoginDropdownOpen(false);
                          }}
                          style={{ 
                            padding: '12px 20px', 
                            display: 'block',
                            color: '#333',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          Counter Login
                        </a>
                        <a 
                          className="dropdown-item" 
                          href="javascript:void(0)" 
                          onClick={() => {
                            handleUser();
                            setLoginDropdownOpen(false);
                          }}
                          style={{ 
                            padding: '12px 20px', 
                            display: 'block',
                            color: '#333',
                            textDecoration: 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          Ticket Inspector
                        </a>
                      </div>
                    )}
                  </div> */}
                  </div>
                  {isOpen ? (
                    <div className="navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                      <ul id="nav" className="navbar-nav ms-auto">
                        <li className="nav-item">
                          <a href="#home" className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Home</a>
                        </li>
                        <li className="nav-item">
                          <a href="#services" onClick={handleServicesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Services</a>
                        </li>
                        <li className="nav-item">
                          <a
                            href="/contact"
                            onClick={handleContactClick}
                            className="page-scroll active"
                            aria-label="Toggle navigation"
                            style={{
                              position: 'relative',
                              transition: 'all 0.3s ease',
                              display: 'inline-block',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.color = '#1976d2';
                              e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.color = '';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            Contact
                          </a>
                        </li>
                        <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleEvents} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Events</a>
                        </li>
                        {/* <li className="nav-item">
                          <a href="#how-it-works" onClick={handleHowItWorksClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >How It Works</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="#features" onClick={handleFeaturesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Features</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                        </li> */}
                        <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Register Your Business</a>
                        </li>
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active" aria-label="Toggle navigation">Ticket Inspector</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active" aria-label="Toggle navigation">Privacy Policy</a>
                        </li> */}
                       
                      </ul>
                    </div>
                  ) : (
                    <div className="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                      <ul id="nav" className="navbar-nav ms-auto">
                        <li className="nav-item">
                          <a href="#home" className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Home</a>
                        </li>
                        <li className="nav-item">
                          <a href="#services" onClick={handleServicesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Services</a>
                        </li>
                        <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleEvents} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Events</a>
                        </li>
                        {/* <li className="nav-item">
                          <a href="#how-it-works" onClick={handleHowItWorksClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >How It Works</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="#features" onClick={handleFeaturesClick} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Features</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleOpen} className="page-scroll active">Client Login</a>
                        </li> */}
                        <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleChange} className="page-scroll active" aria-label="Toggle navigation" style={{
                            position: 'relative',
                            transition: 'all 0.3s ease',
                            display: 'inline-block'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = '#1976d2';
                            e.target.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = '';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          >Register Your Business</a>
                        </li>
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleLogin} className="page-scroll active" aria-label="Toggle navigation">Counter Login</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handleUser} className="page-scroll active" aria-label="Toggle navigation">Ticket Inspector</a>
                        </li> */}
                        {/* <li className="nav-item">
                          <a href="javascript:void(0)" onClick={handlePrivacyPolicy} className="page-scroll active" aria-label="Toggle navigation">Privacy Policy</a>
                        </li> */}
                       
                      </ul>
                      <div className="dropdown" ref={loginDropdownRef} style={{ position: 'relative', marginLeft: '15px' }}>
                        <button 
                          className="btn btn-primary" 
                          type="button" 
                          onClick={toggleLoginDropdown}
                          style={{ 
                            backgroundColor: '#ffffff', 
                            color: '#1976d2',
                            border: '2px solid #1976d2',
                            padding: '8px 20px',
                            borderRadius: '30px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 600,
                            textTransform: 'none',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#1976d2';
                            e.target.style.color = '#ffffff';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#ffffff';
                            e.target.style.color = '#1976d2';
                          }}
                        >
                          Login
                        </button>
                        {loginDropdownOpen && (
                          <div 
                            className="dropdown-menu show" 
                            style={{ 
                              position: 'absolute', 
                              right: 0, 
                              top: '100%',
                              minWidth: '180px',
                              zIndex: 1000,
                              backgroundColor: 'white',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              borderRadius: '8px',
                              padding: '8px 0',
                              marginTop: '8px'
                            }}
                          >
                            <a 
                              className="dropdown-item" 
                              href="javascript:void(0)" 
                              onClick={() => {
                                handleOpen();
                                setLoginDropdownOpen(false);
                              }}
                              style={{ 
                                padding: '12px 20px', 
                                display: 'block',
                                color: '#333',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                transition: 'background-color 0.2s'
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                              Client Login
                            </a>
                            <a 
                              className="dropdown-item" 
                              href="javascript:void(0)" 
                              onClick={() => {
                                handleLogin();
                                setLoginDropdownOpen(false);
                              }}
                              style={{ 
                                padding: '12px 20px', 
                                display: 'block',
                                color: '#333',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                transition: 'background-color 0.2s'
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                              Counter Login
                            </a>
                            <a 
                              className="dropdown-item" 
                              href="javascript:void(0)" 
                              onClick={() => {
                                handleUser();
                                setLoginDropdownOpen(false);
                              }}
                              style={{ 
                                padding: '12px 20px', 
                                display: 'block',
                                color: '#333',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                fontSize: '14px',
                                transition: 'background-color 0.2s'
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                              Ticket Inspector
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default withRouter(Header);
